import merge from 'lodash/merge';
import emitUpdateQueryInteractionEvent from './emitUpdateQueryInteractionEvent';
import emitClearFiltersEvent from './emitClearFiltersEvent';
import emitDismissSearchMessagingEvent from './emitDismissSearchMessagingEvent';
import emitMapRedoSearchClickEvent from './emitMapRedoSearchClickEvent';
import emitMapPropertyMarkerClickedEvent from './emitMapPropertyMarkerClickedEvent';
import emitUserInteractionEvent from './emitUserInteractionEvent';
import emitSplitTreatmentsEvent from './emitSplitTreatmentsEvent';
import emitLocationChangeEvent from './emitLocationChangeEvent';
import emitFetchSearchResultsSuccessEvent from './emitFetchSearchResultsSuccessEvent';
import emitOpenPointsClubModalEvent from './emitOpenPointsClubModalEvent';
import emitSsoEvents from './emitSsoEvents';
import emitTransReadyEvent from './emitTransReadyEvent';
import emitScrollTrackingEvent from './emitScrollTrackingEvent';
import emitPropertyRoomTypeFiltersInteractionEvent from './emitPropertyRoomTypeFiltersInteractionEvent';

export default merge(
  emitUpdateQueryInteractionEvent,
  emitClearFiltersEvent,
  emitDismissSearchMessagingEvent,
  emitMapRedoSearchClickEvent,
  emitMapPropertyMarkerClickedEvent,
  emitUserInteractionEvent,
  emitSplitTreatmentsEvent,
  emitLocationChangeEvent,
  emitFetchSearchResultsSuccessEvent,
  emitOpenPointsClubModalEvent,
  emitSsoEvents,
  emitTransReadyEvent,
  emitScrollTrackingEvent,
  emitPropertyRoomTypeFiltersInteractionEvent,
);
